<template>
    <div class="ciyun2">
        <div class="ciyun2-box-item animate__animated animate__delay-2s" v-for="(item, index) in valuedata" :key="index"
            :style="{ width: item.width + 'px', height: item.height - 8 + 'px', color: item.color, fontSize: 16 + 'px', opcaity: item.opcaity }"
            :class="item.class">
            <div class="ciyun2-box-item-name" :style="{width: item.width + 'px'}" :title="item.value1">{{ item.value1 }}</div>
            <div class="ciyun2-box-item-value">{{ item.value2 }}</div>
        </div>
    </div>
</template>
<script>
import * as methods from './method.js'
export default {
    //词云2
    name: 'template.scope22',
    props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => {}
		}
	},
    data() {
        return {
            title: '词云图-scope22',
            valuedata: [],
            timer: null,
            defaultdata: [
                { value1: "文本一", value2: 300 },
                { value1: "文本二", value2: 600 },
                { value1: "文本三", value2: 700 },
                { value1: "文本四", value2: 800 },
                { value1: "文本五", value2: 900 },
                { value1: "文本六", value2: 1000 },
                { value1: "文本七", value2: 1100 },
                { value1: "文本八", value2: 1200 },
            ],
            valueMap: [
                { name: '名称', key: 'value1' },
                { name: '数值', key: 'value2' }
            ],
            exceldata: [],
            apiconfig: {},
			isApi: false,
			scope: {}
        }
    },
    watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.Drawecharts()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer)
		this.timer = null
	},
    mounted() {
        if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
        this.setData()
        this.Drawecharts();
    },
    methods: {
        ...methods,
        Drawecharts() {
            let vdata = JSON.parse(JSON.stringify(this.defaultdata))
            vdata = vdata.sort((a, b) => {
                return +b.value2 - +a.value2
            })
            let max = +vdata[0].value2
            vdata.forEach((item, index) => {
                let bl = parseFloat(+item.value2 / max.toFixed(2))
                item.color = `rgba(255, 255, 255, ${bl})`
                item.opcaity = .7
                if (bl < 0.5 && bl > 0.3) {
                    item.width = (bl + 0.2) * 100
                    item.height = (bl + 0.2) * 100
                    item.size = (bl + 0.2) * 20
                } else if (bl < 0.3) {
                    item.width = (bl + 0.3) * 100
                    item.height = (bl + 0.3) * 100
                    item.size = (bl + 0.3) * 20
                } else {
                    item.width = (bl + 0.1) * 80
                    item.height = (bl + 0.1) * 80
                    item.size = (bl) * 20
                }
            })
            this.valuedata = vdata
        },
    }
}
</script>
<style lang="scss" scoped>
@keyframes randomOpacity {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

@keyframes randomOpacity2 {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.2;
    }

    100% {
        opacity: 1;
    }
}

@keyframes randomOpacity3 {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.3;
    }

    100% {
        opacity: 1;
    }
}

.ciyun2 {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;
    width: 435px;
    height: 240px;

    .ciyun2-box-item {
        line-height: 20px;
        border-radius: 50%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-image: url("@/assets/RN/ciyun2.png");
        background-repeat: no-repeat;
        background-size: 100%;
        position: absolute;
        cursor: pointer;
    }

    .ciyun2-box-item:nth-child(3n) {
        animation: randomOpacity 2s infinite;
    }

    .ciyun2-box-item:nth-child(3n-1) {
        animation: randomOpacity2 5s infinite;
    }

    .ciyun2-box-item:nth-child(3n-2) {
        animation: randomOpacity3 6s infinite;
    }

    .ciyun2-box-item:nth-child(1) {
        left: 55%;
        top: 48%;
        transform: translate(-50%, -50%);
    }

    .ciyun2-box-item:nth-child(2) {
        left: 35%;
        top: 30%;
        transform: translate(-50%, -50%);
    }

    .ciyun2-box-item:nth-child(3) {
        left: 75%;
        top: 40%;
        transform: translate(-50%, -50%);
    }

    .ciyun2-box-item:nth-child(4) {
        left: 20%;
        top: 65%;
        transform: translate(-50%, -50%);
    }

    .ciyun2-box-item:nth-child(5) {
        left: 80%;
        top: 73%;
        transform: translate(-50%, -50%);
    }

    .ciyun2-box-item:nth-child(6) {
        left: 50%;
        top: 15%;
        transform: translate(-50%, -50%);
    }

    .ciyun2-box-item:nth-child(7) {
        left: 61%;
        top: 82%;
        transform: translate(-50%, -50%);
    }

    .ciyun2-box-item:nth-child(8) {
        left: 40%;
        top: 70%;
        transform: translate(-50%, -50%);
    }

    .ciyun2-box-item:nth-child(9) {
        left: 10%;
        top: 40%;
        transform: translate(-50%, -50%);
    }

    .ciyun2-box-item:nth-child(10) {
        left: 70%;
        top: 15%;
        transform: translate(-50%, -50%);
    }

    .ciyun2-box-item:nth-child(11) {
        left: 60%;
        top: 80%;
        transform: translate(-50%, -50%);
    }

    .ciyun2-box-item:nth-child(12) {
        left: 90%;
        top: 20%;
        transform: translate(-50%, -50%);
    }
    .ciyun2-box-item-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style> 